import { styled } from "@mui/material/styles";
import { Box, InternalStandardProps } from "@mui/material";
import { config } from "JS/Config";
import { Tabs } from "JS/Helpers/FycStatusConstants";

const TabContainer = styled(Box)(() => ({
    marginBottom: "40px",
}));

const Tab = styled(Box)(({ theme }) => ({
    cursor: "pointer",
    fontSize: "1rem",
    color: theme.palette.grey[400],
    fontWeight: 500,
}));

const TabWithBorder = styled(Tab)(({ theme }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: "5px",
    padding: "10px 15px",
}));

const ActiveTab = styled(TabWithBorder)(({ theme }) => ({
    color: theme.colors.white,
    backgroundColor: theme.palette.grey[900],
    border: `2px solid ${theme.palette.grey[900]}`,
}));

export interface userTabsProps
    extends InternalStandardProps<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        >
    > {
    isSecondaryActive: boolean;
    handleTabSwitch: (userId: string) => void;
    hasSpouse: boolean;
    showPrimaryUser: boolean;
}

export const UserTabs = (props: userTabsProps) => {
    const { isSecondaryActive, handleTabSwitch, hasSpouse, showPrimaryUser } =
        props;

    const memberId = config?.user?.memberId;

    const renderPrimaryTab = () => {
        if (!isSecondaryActive && hasSpouse) {
            return (
                <ActiveTab
                    key={memberId}
                    onClick={() => handleTabSwitch(config?.user?.memberId)}
                    sx={{ marginRight: "5px" }}
                >
                    {Tabs.PRIMARY_USER}
                </ActiveTab>
            );
        }
        if (hasSpouse) {
            return (
                <TabWithBorder
                    key={memberId}
                    onClick={() => handleTabSwitch(config?.user?.memberId)}
                    sx={{ marginRight: "5px" }}
                >
                    {Tabs.PRIMARY_USER}
                </TabWithBorder>
            );
        }
        if (!isSecondaryActive) {
            return (
                <ActiveTab
                    key={memberId}
                    onClick={() => handleTabSwitch(config?.user?.memberId)}
                >
                    {Tabs.PRIMARY_USER}
                </ActiveTab>
            );
        }
        return (
            <Tab
                key={memberId}
                onClick={() => handleTabSwitch(config?.user?.memberId)}
            >
                {Tabs.PRIMARY_USER}
            </Tab>
        );
    };

    const renderSecondaryTab = () => {
        if (isSecondaryActive) {
            return (
                <ActiveTab
                    key={memberId + "2"}
                    onClick={() =>
                        handleTabSwitch(config?.user?.memberId + "2")
                    }
                    sx={{ marginLeft: "5px" }}
                >
                    {Tabs.SECONDARY_USER}
                </ActiveTab>
            );
        }
        return (
            <TabWithBorder
                key={memberId + "2"}
                onClick={() => handleTabSwitch(config?.user?.memberId + "2")}
                sx={{ marginLeft: "5px" }}
            >
                {Tabs.SECONDARY_USER}
            </TabWithBorder>
        );
    };

    return (
        <TabContainer display={"flex"} justifyContent={"center"}>
            {showPrimaryUser && renderPrimaryTab()}
            {hasSpouse && renderSecondaryTab()}
        </TabContainer>
    );
};
